import { NgModule } from '@angular/core';

import { SearchIconComponent } from './icons/search-icon/search-icon.component';
import { SignalIconComponent } from './icons/signal-icon/signal-icon.component';
import { SortArrowDownIconComponent } from './icons/sort-arrow-down-icon/sort-arrow-down-icon.component';
import { AcademicCapIconComponent } from './icons/academic-cap-icon/academic-cap-icon.component';
import { AcType0IconComponent } from './icons/ac-types/ac-type-0-icon/ac-type-0-icon.component';
import { AcType1IconComponent } from './icons/ac-types/ac-type-1-icon/ac-type-1-icon.component';
import { AcType10IconComponent } from './icons/ac-types/ac-type-10-icon/ac-type-10-icon.component';
import { AcType11IconComponent } from './icons/ac-types/ac-type-11-icon/ac-type-11-icon.component';
import { AcType2IconComponent } from './icons/ac-types/ac-type-2-icon/ac-type-2-icon.component';
import { AcType3IconComponent } from './icons/ac-types/ac-type-3-icon/ac-type-3-icon.component';
import { AcType4IconComponent } from './icons/ac-types/ac-type-4-icon/ac-type-4-icon.component';
import { AcType5IconComponent } from './icons/ac-types/ac-type-5-icon/ac-type-5-icon.component';
import { AcType6IconComponent } from './icons/ac-types/ac-type-6-icon/ac-type-6-icon.component';
import { AcType7IconComponent } from './icons/ac-types/ac-type-7-icon/ac-type-7-icon.component';
import { AcType8IconComponent } from './icons/ac-types/ac-type-8-icon/ac-type-8-icon.component';
import { AcType9IconComponent } from './icons/ac-types/ac-type-9-icon/ac-type-9-icon.component';
import { AcTypeNullIconComponent } from './icons/ac-types/ac-type-null-icon/ac-type-null-icon.component';
import { ArrowDownIconComponent } from './icons/arrow-down-icon/arrow-down-icon.component';
import { ArrowToRightIconComponent } from './icons/arrow-to-right-icon/arrow-to-right-icon.component';
import { BanIconComponent } from './icons/ban-icon/ban-icon.component';
import { BellIconComponent } from './icons/bell-icon/bell-icon.component';
import { BoltIconComponent } from './icons/bolt-icon/bolt-icon.component';
import { BurgerMenuIconComponent } from './icons/burger-menu-icon/burger-menu-icon.component';
import { CadImportIconComponent } from './icons/cad-import-icon/cad-import-icon.component';
import { CalendarAltIconComponent } from './icons/calendar-alt-icon/calendar-alt-icon.component';
import { CalendarCheckIconComponent } from './icons/calendar-check-icon/calendar-check-icon.component';
import { CalendarIconComponent } from './icons/calendar-icon/calendar-icon.component';
import { CaretDownIconComponent } from './icons/caret-down-icon/caret-down-icon.component';
import { CaretUpIconComponent } from './icons/caret-up-icon/caret-up-icon.component';
import { CheckThinIconComponent } from './icons/check-thin-icon/check-thin-icon.component';
import { CheckmarkIconComponent } from './icons/checkmark-icon/checkmark-icon.component';
import { ClipIconComponent } from './icons/clip-icon/clip-icon.component';
import { ClipboardIconComponent } from './icons/clipboard-icon/clipboard-icon.component';
import { ClockIconComponent } from './icons/clock-icon/clock-icon.component';
import { CommentIconComponent } from './icons/comment-icon/comment-icon.component';
import { CrossIconComponent } from './icons/cross-icon/cross-icon.component';
import { DashboardIconComponent } from './icons/dashboard-icon/dashboard-icon.component';
import { DocFormatAviFileIconComponent } from './icons/doc-formats/doc-format-avi-file-icon/doc-format-avi-file-icon.component';
import { DocFormatBmpFileIconComponent } from './icons/doc-formats/doc-format-bmp-file-icon/doc-format-bmp-file-icon.component';
import { DocFormatDocFileIconComponent } from './icons/doc-formats/doc-format-doc-file-icon/doc-format-doc-file-icon.component';
import { DocFormatDocxFileIconComponent } from './icons/doc-formats/doc-format-docx-file-icon/doc-format-docx-file-icon.component';
import { DocFormatGifFileIconComponent } from './icons/doc-formats/doc-format-gif-file-icon/doc-format-gif-file-icon.component';
import { DocFormatJpegFileIconComponent } from './icons/doc-formats/doc-format-jpeg-file-icon/doc-format-jpeg-file-icon.component';
import { DocFormatJpgFileIconComponent } from './icons/doc-formats/doc-format-jpg-file-icon/doc-format-jpg-file-icon.component';
import { DocFormatMovFileIconComponent } from './icons/doc-formats/doc-format-mov-file-icon/doc-format-mov-file-icon.component';
import { DocFormatMp3FileIconComponent } from './icons/doc-formats/doc-format-mp3-file-icon/doc-format-mp3-file-icon.component';
import { DocFormatMp4FileIconComponent } from './icons/doc-formats/doc-format-mp4-file-icon/doc-format-mp4-file-icon.component';
import { DocFormatPdfFileIconComponent } from './icons/doc-formats/doc-format-pdf-file-icon/doc-format-pdf-file-icon.component';
import { DocFormatPngFileIconComponent } from './icons/doc-formats/doc-format-png-file-icon/doc-format-png-file-icon.component';
import { DocFormatPptFileIconComponent } from './icons/doc-formats/doc-format-ppt-file-icon/doc-format-ppt-file-icon.component';
import { DocFormatPptxFileIconComponent } from './icons/doc-formats/doc-format-pptx-file-icon/doc-format-pptx-file-icon.component';
import { DocFormatTxtFileIconComponent } from './icons/doc-formats/doc-format-txt-file-icon/doc-format-txt-file-icon.component';
import { DocFormatWmvFileIconComponent } from './icons/doc-formats/doc-format-wmv-file-icon/doc-format-wmv-file-icon.component';
import { DocFormatWpdFileIconComponent } from './icons/doc-formats/doc-format-wpd-file-icon/doc-format-wpd-file-icon.component';
import { DocFormatXlsFileIconComponent } from './icons/doc-formats/doc-format-xls-file-icon/doc-format-xls-file-icon.component';
import { DocFormatXlsxFileIconComponent } from './icons/doc-formats/doc-format-xlsx-file-icon/doc-format-xlsx-file-icon.component';
import { DoubleArrowRightIconComponent } from './icons/double-arrow-right-icon/double-arrow-right-icon.component';
import { EditIconComponent } from './icons/edit-icon/edit-icon.component';
import { ExcelFileIconComponent } from './icons/excel-file-icon/excel-file-icon.component';
import { ExclamationCircleIconComponent } from './icons/exclamation-circle-icon/exclamation-circle-icon.component';
import { ExclamationMarkIconComponent } from './icons/exclamation-mark-icon/exclamation-mark-icon.component';
import { ExternalLinkIconComponent } from './icons/external-link-icon/external-link-icon.component';
import { EyeOffIconComponent } from './icons/eye-off-icon/eye-off-icon.component';
import { EyeIconComponent } from './icons/eye-icon/eye-icon.component';
import { FilledQuestionIconComponent } from './icons/filled-question-icon/filled-question-icon.component';
import { FilterIconComponent } from './icons/filter-icon/filter-icon.component';
import { FileIconComponent } from './icons/file-icon/file-icon.component';
import { FolderIconBlueComponent } from './icons/add-ons/folder-icon-blue/folder-icon-blue.component';
import { FolderIconComponent } from './icons/add-ons/folder-icon/folder-icon.component';
import { GearsIconComponent } from './icons/gears-icon/gears-icon.component';
import { GearIconComponent } from './icons/gear-icon/gear-icon.component';
import { HighFiveIconComponent } from './icons/high-five-icon/high-five-icon.component';
import { InfoIconComponent } from './icons/info-icon/info-icon.component';
import { InfoThinIconComponent } from './icons/info-thin-icon/info-thin-icon.component';
import { LockIconComponent } from './icons/lock-icon/lock-icon.component';
import { LogoutIconComponent } from './icons/logout-icon/logout-icon.component';
import { MailIconComponent } from './icons/mail-icon/mail-icon.component';
import { MapMarkIconComponent } from './icons/map-mark-icon/map-mark-icon.component';
import { MedalIconComponent } from './icons/medal-icon/medal-icon.component';
import { MoonIconComponent } from './icons/moon-icon/moon-icon.component';
import { NoChoseIconComponent } from './icons/no-chose-icon/no-chose-icon.component';
import { NoteIconComponent } from './icons/note-icon/note-icon.component';
import { PhoneIconComponent } from './icons/phone-icon/phone-icon.component';
import { PdfFileIconComponent } from './icons/pdf-file-icon/pdf-file-icon.component';
import { PowerDmsLogoIconComponent } from './icons/add-ons/power-dms-logo-icon/power-dms-logo-icon.component';
import { PrinterIconComponent } from './icons/printer-icon/printer-icon.component';
import { RedoIconComponent } from './icons/redo-icon/redo-icon.component';
import { SortArrowIconComponent } from './icons/sort-arrow-icon/sort-arrow-icon.component';
import { SpinnerIconComponent } from './icons/spinner-icon/spinner-icon.component';
import { StarIconComponent } from './icons/star-icon/star-icon.component';
import { SparklesIconComponent } from './icons/sparkles-icon/sparkles-icon.component';
import { SunIconComponent } from './icons/sun-icon/sun-icon.component';
import { TasksIconComponent } from './icons/tasks-icon/tasks-icon.component';
import { ThumbsDownIconComponent } from './icons/thumbs-down-icon/thumbs-down-icon.component';
import { ThumbsDownUnfilledIconComponent } from './icons/thumbs-down-unfilled-icon/thumbs-down-unfilled-icon.component';
import { ThumbsUpIconComponent } from './icons/thumbs-up-icon/thumbs-up-icon.component';
import { ThumbsUpUnfilledIconComponent } from './icons/thumbs-up-unfilled-icon/thumbs-up-unfilled-icon.component';
import { ToolsIconComponent } from './icons/tools-icon/tools-icon.component';
import { TrashBinIconComponent } from './icons/trash-bin-icon/trash-bin-icon.component';
import { UserFolderIconComponent } from './icons/user-folder-icon/user-folder-icon.component';
import { UserIconComponent } from './icons/user-icon/user-icon.component';
import { UsersIconComponent } from './icons/users-icon/users-icon.component';
import { WarningIconComponent } from './icons/warning-icon/warning-icon.component';
import { WarningThinIconComponent } from './icons/warning-thin-icon/warning-thin-icon.component';
import { GroupIconComponent } from './icons/group-icon/group-icon.component';
import { ArrowLeftIconComponent } from './content/icon/arrow-left-icon.component';
import { ArrowRightIconComponent } from './content/icon/arrow-right-icon.component';

@NgModule({
  declarations: [
    AcademicCapIconComponent,
    AcType0IconComponent,
    AcType1IconComponent,
    AcType10IconComponent,
    AcType11IconComponent,
    AcType2IconComponent,
    AcType3IconComponent,
    AcType4IconComponent,
    AcType5IconComponent,
    AcType6IconComponent,
    AcType7IconComponent,
    AcType8IconComponent,
    AcType9IconComponent,
    AcTypeNullIconComponent,
    ArrowDownIconComponent,
    ArrowToRightIconComponent,
    BanIconComponent,
    BellIconComponent,
    BoltIconComponent,
    BurgerMenuIconComponent,
    CadImportIconComponent,
    CalendarAltIconComponent,
    CalendarCheckIconComponent,
    CalendarIconComponent,
    CaretDownIconComponent,
    CaretUpIconComponent,
    CheckmarkIconComponent,
    CheckThinIconComponent,
    ClipIconComponent,
    ClipboardIconComponent,
    ClockIconComponent,
    CommentIconComponent,
    CrossIconComponent,
    DashboardIconComponent,
    DocFormatAviFileIconComponent,
    DocFormatBmpFileIconComponent,
    DocFormatDocFileIconComponent,
    DocFormatDocxFileIconComponent,
    DocFormatGifFileIconComponent,
    DocFormatJpegFileIconComponent,
    DocFormatJpgFileIconComponent,
    DocFormatMovFileIconComponent,
    DocFormatMp3FileIconComponent,
    DocFormatMp4FileIconComponent,
    DocFormatPdfFileIconComponent,
    DocFormatPngFileIconComponent,
    DocFormatPptFileIconComponent,
    DocFormatPptxFileIconComponent,
    DocFormatTxtFileIconComponent,
    DocFormatWmvFileIconComponent,
    DocFormatWpdFileIconComponent,
    DocFormatXlsFileIconComponent,
    DocFormatXlsxFileIconComponent,
    DoubleArrowRightIconComponent,
    EditIconComponent,
    ExcelFileIconComponent,
    ExclamationCircleIconComponent,
    ExclamationMarkIconComponent,
    ExternalLinkIconComponent,
    EyeOffIconComponent,
    EyeIconComponent,
    FilledQuestionIconComponent,
    FilterIconComponent,
    FileIconComponent,
    FolderIconBlueComponent,
    FolderIconComponent,
    GearsIconComponent,
    GearIconComponent,
    HighFiveIconComponent,
    InfoIconComponent,
    InfoThinIconComponent,
    LockIconComponent,
    LogoutIconComponent,
    MailIconComponent,
    MapMarkIconComponent,
    MedalIconComponent,
    MoonIconComponent,
    NoChoseIconComponent,
    NoteIconComponent,
    PhoneIconComponent,
    PdfFileIconComponent,
    PowerDmsLogoIconComponent,
    PrinterIconComponent,
    RedoIconComponent,
    SearchIconComponent,
    SignalIconComponent,
    SortArrowDownIconComponent,
    SortArrowIconComponent,
    SpinnerIconComponent,
    StarIconComponent,
    SparklesIconComponent,
    SunIconComponent,
    TasksIconComponent,
    ThumbsDownIconComponent,
    ThumbsDownUnfilledIconComponent,
    ThumbsUpIconComponent,
    ThumbsUpUnfilledIconComponent,
    ToolsIconComponent,
    TrashBinIconComponent,
    UserFolderIconComponent,
    UserIconComponent,
    UsersIconComponent,
    WarningIconComponent,
    WarningThinIconComponent,
    GroupIconComponent,
    ArrowLeftIconComponent,
    ArrowRightIconComponent
  ],
  exports: [
    AcademicCapIconComponent,
    AcType0IconComponent,
    AcType1IconComponent,
    AcType10IconComponent,
    AcType11IconComponent,
    AcType2IconComponent,
    AcType3IconComponent,
    AcType4IconComponent,
    AcType5IconComponent,
    AcType6IconComponent,
    AcType7IconComponent,
    AcType8IconComponent,
    AcType9IconComponent,
    AcTypeNullIconComponent,
    ArrowDownIconComponent,
    ArrowToRightIconComponent,
    BanIconComponent,
    BellIconComponent,
    BoltIconComponent,
    BurgerMenuIconComponent,
    CadImportIconComponent,
    CalendarAltIconComponent,
    CalendarCheckIconComponent,
    CalendarIconComponent,
    CaretDownIconComponent,
    CaretUpIconComponent,
    CheckmarkIconComponent,
    CheckThinIconComponent,
    ClipIconComponent,
    ClipboardIconComponent,
    ClockIconComponent,
    CommentIconComponent,
    CrossIconComponent,
    DashboardIconComponent,
    DocFormatAviFileIconComponent,
    DocFormatBmpFileIconComponent,
    DocFormatDocFileIconComponent,
    DocFormatDocxFileIconComponent,
    DocFormatGifFileIconComponent,
    DocFormatJpegFileIconComponent,
    DocFormatJpgFileIconComponent,
    DocFormatMovFileIconComponent,
    DocFormatMp3FileIconComponent,
    DocFormatMp4FileIconComponent,
    DocFormatPdfFileIconComponent,
    DocFormatPngFileIconComponent,
    DocFormatPptFileIconComponent,
    DocFormatPptxFileIconComponent,
    DocFormatTxtFileIconComponent,
    DocFormatWmvFileIconComponent,
    DocFormatWpdFileIconComponent,
    DocFormatXlsFileIconComponent,
    DocFormatXlsxFileIconComponent,
    DoubleArrowRightIconComponent,
    EditIconComponent,
    ExcelFileIconComponent,
    ExclamationCircleIconComponent,
    ExclamationMarkIconComponent,
    ExternalLinkIconComponent,
    EyeOffIconComponent,
    EyeIconComponent,
    FilledQuestionIconComponent,
    FilterIconComponent,
    FileIconComponent,
    FolderIconBlueComponent,
    FolderIconComponent,
    GearsIconComponent,
    GearIconComponent,
    HighFiveIconComponent,
    InfoIconComponent,
    InfoThinIconComponent,
    LockIconComponent,
    LogoutIconComponent,
    MailIconComponent,
    MapMarkIconComponent,
    MedalIconComponent,
    MoonIconComponent,
    NoChoseIconComponent,
    NoteIconComponent,
    PhoneIconComponent,
    PdfFileIconComponent,
    PowerDmsLogoIconComponent,
    PrinterIconComponent,
    RedoIconComponent,
    SearchIconComponent,
    SignalIconComponent,
    SortArrowDownIconComponent,
    SortArrowIconComponent,
    SpinnerIconComponent,
    StarIconComponent,
    SparklesIconComponent,
    SunIconComponent,
    TasksIconComponent,
    ThumbsDownIconComponent,
    ThumbsDownUnfilledIconComponent,
    ThumbsUpIconComponent,
    ThumbsUpUnfilledIconComponent,
    ToolsIconComponent,
    TrashBinIconComponent,
    UserFolderIconComponent,
    UserIconComponent,
    UsersIconComponent,
    WarningIconComponent,
    WarningThinIconComponent,
    GroupIconComponent,
    ArrowLeftIconComponent,
    ArrowRightIconComponent
  ]
})
export class IconsModule {}
